import React from "react";

import { Box, Typography } from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";
import ConfirmationPopup from "components/common/ConfirmationPopup";

interface RestrictPatientModalProps {
  open: boolean;
  isRestricted: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const RestrictPatientModal: React.FC<RestrictPatientModalProps> = ({
  open,
  isRestricted,
  onClose,
  onConfirm,
  loading = false,
}) => {
  const { colors } = useCelleraTheme();

  const title = isRestricted
    ? "Unrestrict Patient Account"
    : "Restrict Patient Account";

  const message = isRestricted ? (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 1, py: 2, px: 3 }}
    >
      <Typography sx={{ color: colors.text.primary }}>
        Are you sure you want to unrestrict this patient account?
      </Typography>
      <Typography sx={{ color: colors.text.primary }}>
        They will be able to log in and use the Cellera app again
      </Typography>
    </Box>
  ) : (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 1, py: 2, px: 3 }}
    >
      <Typography sx={{ color: colors.text.primary }}>
        Are you sure you want to restrict this patient account?
      </Typography>
      <Typography sx={{ color: colors.text.primary }}>
        They will be unable to log in and use the Cellera app
      </Typography>
    </Box>
  );

  const confirmColor = isRestricted ? colors.primary.main : colors.error[500];
  const confirmHoverColor = isRestricted
    ? colors.primary.dark
    : colors.error[700];
  const confirmText = isRestricted ? "Unrestrict" : "Restrict";

  return (
    <ConfirmationPopup
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={message}
      confirmText={confirmText}
      cancelText="Cancel"
      confirmColor={confirmColor}
      confirmHoverColor={confirmHoverColor}
      loading={loading}
      iconColor={colors.text.inverse}
      iconBackgroundColor={confirmColor}
      maxWidth="sm"
      paperSx={{
        borderRadius: 4,
      }}
    />
  );
};

export default RestrictPatientModal;
